import React, { StrictMode } from 'react';
import { hot } from 'react-hot-loader';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import s from '../index.scss';

const App = () => (
	<StrictMode>
		<Header />
		<div className={s.main}>
			<Switcher />
		</div>
		<Footer />
	</StrictMode>
);

export default hot(module)(App);
